import { createAction, createAsyncThunk } from '@betty/toolkit/state';
import { DepositApprovedEventData } from '../deposit/deposit.types';
import { WithdrawalLimits } from '../../services/PaymentService/PaymentService.schema';
import { AvailablePaymentProviders } from '../../services/WalletService/WalletService.schemas';
import PaymentService from '../../services/PaymentService/PaymentService';
import WalletService from '../../services/WalletService/WalletService';

export const openWithdrawal = createAsyncThunk(
  'withdrawal/open',
  async (_, thunkApi) => {
    const { minAmount } = await thunkApi.dispatch(getWithdrawLimits()).unwrap();

    return { minAmount };
  },
);

export const withdrawalApproved = createAction<DepositApprovedEventData>(
  'withdrawal/approved',
);

export const getWithdrawLimits = createAsyncThunk<WithdrawalLimits>(
  'account/getWithdrawLimits',
  async () => {
    const withdrawLimits = await PaymentService.getWithdrawLimits();

    return withdrawLimits;
  },
);

export const getAvailablePaymentProviders =
  createAsyncThunk<AvailablePaymentProviders>(
    'account/getAvailablePaymentProviders',
    async () => {
      const availablePaymentProviders =
        await WalletService.getAvailablePaymentProviders();

      return availablePaymentProviders;
    },
  );
